import React from 'react';

import {
    Box,
    Divider,
    Grid,
    Stack,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormCheck,
    ReactHookFormIntlNumberInput,
    ReactHookFormToggleButtonGroupV2,
} from 'common/components/form';

import {
    getAppendText,
    getPreAppendText,
    handleOnBlurField,
} from '../../helpers';

const CommisionCreditFields = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters_commission_credit';

    const parametersCommissionCredit = useWatch({ control, name });

    return (
        <Box>
            <Typography fontWeight={600} variant="body2">
                {t('Commission for opening')}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Grid container>
                <ReactHookFormCheck
                    control={control}
                    disabled={disabled}
                    name={`${name}.isChecked`}
                />

                <Grid size="grow">
                    <Stack>
                        <Grid container>
                            <Grid size="grow">
                                <ReactHookFormIntlNumberInput
                                    append={getAppendText(
                                        'MXN',
                                        parametersCommissionCredit,
                                    )}
                                    control={control}
                                    disabled={
                                        disabled ||
                                        (parametersCommissionCredit &&
                                            !parametersCommissionCredit.isChecked)
                                    }
                                    fullWidth
                                    label={t('Opening commission')}
                                    name={`${name}.value`}
                                    onBlur={({ value }) =>
                                        handleOnBlurField({
                                            name: `${name}.value`,
                                            setValue,
                                            value,
                                        })
                                    }
                                    prepend={getPreAppendText(
                                        '$',
                                        parametersCommissionCredit,
                                    )}
                                />
                            </Grid>

                            <Grid size={{ sm: 'auto', xs: 18 }}>
                                <ReactHookFormToggleButtonGroupV2
                                    control={control}
                                    disabled={
                                        disabled ||
                                        (parametersCommissionCredit &&
                                            !parametersCommissionCredit.isChecked)
                                    }
                                    fullWidth
                                    name={`${name}.unit`}
                                    options={[
                                        { label: '%', value: 0 },
                                        { label: '$', value: 1 },
                                    ]}
                                    sx={{ minWidth: '120px' }}
                                />
                            </Grid>
                        </Grid>

                        <ReactHookFormIntlNumberInput
                            append="%"
                            control={control}
                            disabled={
                                disabled ||
                                (parametersCommissionCredit &&
                                    !parametersCommissionCredit.isChecked)
                            }
                            fullWidth
                            label={t('Commission VAT')}
                            name={`${name}.opening_commission_vat`}
                            onBlur={({ value }) =>
                                handleOnBlurField({
                                    name: `${name}.opening_commission_vat`,
                                    setValue,
                                    value,
                                })
                            }
                        />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};

CommisionCreditFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default CommisionCreditFields;
